export const exchangeOptions = [
    "usd-$",
    "aed-د.إ",
    "afn-؋",
    "all-L",
    "amd-դր.",
    "ang-ƒ",
    "aoa-Kz",
    "ars-ARS$",
    "aud-A$",
    "awg-ƒ",
    "azn-₼",
    "bam-KM",
    "bbd-$",
    "bdt-Tk",
    "bgn-лв",
    "bhd-ب.د",
    "bif-FBu",
    "bmd-$",
    "bnd-B$",
    "bob-Bs.",
    "brl-R$",
    "bsd-B$",
    "btn-Nu.",
    "bwp-P",
    "byn-Br",
    "bzd-BZ$",
    "cad-C$",
    "cdf-FC",
    "chf-Fr.",
    "clp-CH$",
    "cny-¥",
    "cop-COL$",
    "crc-₡",
    "cup-₱",
    "cve-$",
    "czk-Kč",
    "djf-Fdj",
    "dkk-kr",
    "dop-RD$",
    "dzd-د.ج",
    "egp-E£",
    "ern-Nfk",
    "etb-Br",
    "eur-€",
    "fjd-$",
    "fkp-£",
    "gbp-£",
    "gel-₾",
    "ghs-GH¢",
    "gip-£",
    "gmd-D",
    "gnf-FG",
    "gtq-Q",
    "gyd-$",
    "hkd-HKD",
    "hnl-L",
    "hrk-kn",
    "htg-G",
    "huf-Ft",
    "idr-Rp",
    "ils-₪",
    "inr-₹",
    "iqd-د.ع",
    "irr-﷼",
    "isk-kr",
    "jmd-J$",
    "jod-د.ا",
    "jpy-¥",
    "kes-KSh",
    "kgs-лв",
    "khr-៛",
    "kmf-CF",
    "kpw-₩",
    "krw-₩",
    "kwd-د.ك",
    "kyd-$",
    "kzt-лв",
    "lak-₭",
    "lbp-ل.ل",
    "lkr-ரூ",
    "lrd-$",
    "lsl-M",
    "lyd-LD",
    "mad-د.م.",
    "mdl-L",
    "mga-Ar",
    "mkd-ден",
    "mmk-K",
    "mnt-₮",
    "mop-MOP$",
    "mru-UM",
    "mur-₨",
    "mvr-Rf",
    "mwk-MK",
    "mxn-Mex$",
    "myr-RM",
    "mzn-MT",
    "nad-$",
    "ngn-₦",
    "nio-C$",
    "nok-kr",
    "npr-रु",
    "nzd-NZ$",
    "omr-ر.ع.",
    "pab-B/.",
    "pen-S/.",
    "pgk-K",
    "php-₱",
    "pkr-₨",
    "pln-zł",
    "pyg-₲",
    "qar-ر.ق",
    "ron-lei",
    "rsd-Дин.",
    "rub-₽",
    "rwf-FRw",
    "sar-ر.س",
    "sbd-$",
    "scr-₨",
    "sdg-ج.س.",
    "sek-kr",
    "sgd-$",
    "sll-Le",
    "sos-S",
    "srd-$",
    "stn-Db",
    "syp-£",
    "szl-E",
    "thb-฿",
    "tjs-TJS",
    "tmt-T",
    "tnd-د.ت",
    "top-T$",
    "try-₺",
    "twd-NT$",
    "tzs-TSh",
    "uah-₴",
    "ugx-Sh",
    "uyu-$U",
    "uzs-so'm",
    "ves-Bs",
    "vnd-₫",
    "vuv-VT",
    "wst-WS$",
    "xaf-Fr",
    "xcd-$",
    "xof-CFA",
    "xpf-₣",
    "yer-﷼",
    "zar-R",
];

export const langOptions = [
    { value: "lang-1", text: "English" },
    { value: "lang-2", text: "繁體中文" },
    { value: "lang-3", text: "Русский" },
    { value: "lang-4", text: "한국어" },
    { value: "lang-5", text: "日本語" },
    { value: "lang-6", text: "Tiếng Việt" },
    { value: "lang-7", text: "فارسی" },
    { value: "lang-8", text: "Українська" },
    { value: "lang-9", text: "Español" },
    { value: "lang-10", text: "Français" },
];



// WEBPACK FOOTER //
// ./src/data/lang-switch.js